import localforage from 'localforage';
import moment from 'moment';

export default class CartStorage {
	/**
	 * Getting cart data
	 *
	 * @returns {Promise<unknown>}
	 */
	get() {
		return localforage
			.getItem('cart')
			.then(data => {
				if (data) return Promise.resolve(data);
				return this.set({});
			})
			.catch(err => Promise.reject(err));
	}

	/**
	 * Update cart counter
	 *
	 * @param {object} data
	 */
	updateCartCount(data) {
		let cartItemsCount = Object.keys(data).length;
		cartItemsCount = cartItemsCount === 0 ? '' : cartItemsCount;
		$('#checkout-item-count').text(cartItemsCount);
		$('#mobile-checkout-item-count').text(cartItemsCount);
		$('#checkout-item-count-mobile').text(cartItemsCount);

		if(cartItemsCount !== ''){
			$('#checkout-item-count').removeClass('d-none');
			$('#mobile-checkout-item-count').removeClass('d-none');
		}else {
			$('#checkout-item-count').addClass('d-none');
			$('#mobile-checkout-item-count').addClass('d-none');
		}

	}

	/**
	 * Setting cart data
	 *
	 * @param {object} newData
	 * @returns {Promise<*>}
	 */
	set(newData) {
		return localforage.setItem('cart', newData).then(res => {
			this.updateCartCount(res);
			return res;
		});
	}

	/**
	 * Add one tour
	 *
	 * @param {object} tour
	 * @returns {Promise<*>}
	 */
	addItem(tour) {
		return this.get().then(data => {
			const oldData = data && Object.values(data).length > 0 ? data : {};
			const newData = {
				...oldData,
				[tour.id]: {
					...tour,
					photos: tour.photos && tour.photos.length > 0 ? tour.photos : [{ path_url: '/assets/images/fisher.jpg' }],
					start_date: moment.isMoment(tour.start_date) ? tour.start_date.format('YYYY-MM-DD') : tour.start_date,
				},
			};

			return this.set(newData);
		});
	}

	/**
	 * Delete one cart item
	 *
	 * @param {number||string} id
	 * @returns {Promise<*>}
	 */
	deleteItem(id) {
		return this.get().then(data => {
			const newData = { ...data };

			delete newData[id];
			this.updateCartCount(newData);
			return this.set(newData);
		});
	}
}
